import { render, staticRenderFns } from "./viewLogBook.vue?vue&type=template&id=99c52f28&scoped=true"
import script from "./viewLogBook.vue?vue&type=script&lang=js"
export * from "./viewLogBook.vue?vue&type=script&lang=js"
import style0 from "./viewLogBook.vue?vue&type=style&index=0&id=99c52f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c52f28",
  null
  
)

export default component.exports